<!--
 * @Author: awu
 * @Date: 2020-11-15 13:25:50
 * @LastEditors: awu
 * @LastEditTime: 2020-12-14 21:50:46
 * @Description: 大会议厅-会议议程
-->
<template>
    <div>
        <div class="agenda" v-show="playFlag">
            <div class="backHome" @click="backHome">
                <img src="../../assets/user/close.png" alt="" />
            </div>
            <h1>会议议程</h1>
            <div class="list-no" v-if="this.exhibitionId == '23' || this.exhibitionId == '31'">
                暂无日程
            </div>
            <div class="list" v-else >
                <div style="display:flex;position:relative;" :key="index" v-for="(scheduleItem, index) in scheduleList">
                    <div class="lineBox" :style="{ height: lineBoxHeight + 'px' }">
                        <div v-if="scheduleItem.dotList" class="year" :style="{ top: scheduleItem.dotList[0] - 30 + 'px' }">{{ scheduleItem.year }}</div>
                        <div
                            v-if="scheduleItem.dotList && scheduleItem.lineList"
                            class="dot"
                            v-for="(item, index) in scheduleItem.timeList"
                            :key="index"
                            :style="{ top: scheduleItem.dotList[index] + 'px' }"
                            :class="{
                                active: scheduleItem.itemList[index].data[0].live_status && scheduleItem.itemList[index].data[0].live_status == 2 || scheduleItem.itemList[index].data[0].live_status == 3
                            }"
                        >
                            <div class="date">{{ item }}</div>
                        </div>

                        <div
                            v-if="scheduleItem.dotList && scheduleItem.lineList && index < scheduleItem.dotList.length -1"
                            class="line"
                            v-for="(item, index) in scheduleItem.lineList"
                            :key="item.data"
                            :style="{
                                top: scheduleItem.dotList[index] + 10 + 'px',
                                height: scheduleItem.lineList[index] + 'px'
                            }"
                            :class="{
                                active: scheduleItem.itemList[index].data[0].live_status && scheduleItem.itemList[index].data[0].live_status == 2 || scheduleItem.itemList[index].data[0].live_status == 3
                            }"
                        ></div>
                    </div>
                    <ul ref="ul">
                        <!-- <div class="whiteBox"></div> -->
                        <div class="theme">{{ scheduleItem.theme }}</div>
                        <li class="item" v-for="(item, index) in scheduleItem.itemList" :key="index">
                            <div class="top">
                                <span>{{ item.time }}</span>
                                <h2>{{ item.data[0].title }}</h2>
                            </div>
                            <div class="bottom" v-for="(value, idx) in item.data[0].guests" :key="idx">
                                {{ value.name }}
                                <div class="btn" v-for="values in value.docs" :key="values.com_doc_id">{{ values.doc_name }}</div>
                            </div>
                            <div v-if="item.data[0].live_status == 1" class="playVideo bc" @click="playVideo(item)">
                                <span>敬请期待</span>
                            </div>
                            <div v-if="item.data[0].live_status == 2" class="playVideo" @click="playVideo(item)">
                                <img style="width:13px" src="../../assets/area/isplay.png" alt="" />
                                <span>正在直播</span>
                            </div>
                            <div v-if="item.data[0].live_status == 3" class="playVideo" @click="playVideo(item)">
                                <img src="../../assets/conference/play.png" alt="" />
                                <span>精彩回顾</span>
                            </div>
                        </li>
                        <!-- <div class="whiteBox"></div> -->
                    </ul>
                </div>
            </div>
        </div>
        <Video v-if="!playFlag" @close="close" :src="src" :type="type"></Video>
    </div>
</template>

<script>
import api from "@/api";
import Video from "../video";

export default {
    props: {
        exhibitionId: String
    },
    components: {
        Video
    },
    data() {
        return {
            scheduleList: [],
            tempScheduleItem: {},
            scrollFlag: false,
            lineBoxHeight: 0, // sub
            dotList: [],     // sub
            lineList: [],    // sub
            itemList: [],    // sub
            timeList: [],    // sub
            year: "",        // sub
            playFlag: true,
            src: "",
            type: "application/x-mpegURL"
        };
    },
    mounted() {
        this.getschedule();
    },
    methods: {
        playVideo(item) {
            // hall_id 跳转地址
            console.log(item.data[0]);
            const { live_status,live_url, play_back } = item.data[0];
            // 1-未开始 2-开始 3-回放
            if (live_status == 2) {
                if (!live_url) {
                    this.$message.info(this.$t("tips").noLive);
                    return;
                }
                this.$emit("noShowSchedule");
                this.$root.$emit("close");
                switch (item.data[0].hall_id) {
                    case 1:
                        // 论坛
                        this.$router.push({
                            path: "/area/bigconference",
                            query: {
                                videoSrc: encodeURIComponent(item.data[0].live_url)
                            }
                        });
                        break;
                    case 2:
                        // 路演
                        this.$router.push({
                            path: "/area/smallconference",
                            query: {
                                videoSrc: encodeURIComponent(item.data[0].live_url)
                            }
                        });
                        break;
                    case 0:
                        // 展厅
                        break;
                }
            } else if (live_status == 3) {
                if (!play_back) {
                    this.$message.info(this.$t("tips").noSchedule);
                    return;
                }
                //取视频格式
                let format = play_back.slice(play_back.lastIndexOf('\.'))
                if(format.indexOf('.mp4') > -1) {
                    this.type = 'video/mp4';
                }
                this.playFlag = false;
                this.src = play_back;
            } else if(live_status == 1){
                this.$message.info(this.$t("tips").noLive);
            }
        },
        close() {
            this.playFlag = true;
        },
        getHeight() {
            this.$nextTick(() => {
                let Ali = document.querySelectorAll(".item");
                const dotList = []
                const lineList = []
                for (let i = 0; i < Ali.length; i++) {
                    let dot = Ali[i].offsetTop - 10 + Ali[i].offsetHeight / 2;
                    dotList.push(dot);
                    if (i > 0) {
                        let height = Ali[i].offsetHeight / 2 + Ali[i - 1].offsetHeight / 2 + 33 - 10;
                        lineList.push(height);
                    }
                }

                for(let j = 0; j < this.scheduleList.length; j++) {
                    let currentDotList = [];
                    let currentLineList = [];
                    let currentItemLength = this.scheduleList[j].itemList.length;

                    if(j === 0){
                        currentDotList = [...dotList.slice(0, currentItemLength)];
                        currentLineList = [...lineList.slice(0, currentItemLength)];
                        this.$set(this.scheduleList[0], 'dotList', currentDotList);
                        this.$set(this.scheduleList[0], 'lineList', currentLineList);
                    }else {
                        currentDotList = [...dotList.slice(this.scheduleList[j-1].itemList.length, this.scheduleList[j-1].itemList.length + currentItemLength)];
                        currentLineList = [...lineList.slice(this.scheduleList[j-1].itemList.length, this.scheduleList[j-1].itemList.length + currentItemLength)];
                        this.$set(this.scheduleList[j], 'dotList', currentDotList);
                        this.$set(this.scheduleList[j], 'lineList', currentLineList);
                    }
                    
                }
            });
        },
        backHome() {
            this.$emit("noShowSchedule");
            this.$root.$emit("close");
        },
        getschedule() {
            api.schedule({ hall_id: 3, exhibition_id: this.exhibitionId }).then((res) => {
                console.log(res.data,'data');
                const data = res.data
                for (let i = 0; i < data.length; i++) {
                  let arr1 = [];
                  const resData = data[i].data
                  resData.map((item) => {
                      arr1.push(item);
                  });

                  let arr2 = [];
                  arr1.map((item) => {
                      arr2.push(item.data);
                  });

                  let arr3 = [];
                  arr2.map((item) => {
                      item.map((value) => {
                          arr3.push(value);
                      });
                  });

                  this.$set(this.tempScheduleItem, 'theme', data[i].theme)
                  this.$set(this.tempScheduleItem, 'itemList', arr3)
                  this.$set(this.tempScheduleItem, 'year', resData[0].date.substr(0, 4))

                  let at1 = [];
                  arr1.map((item) => {
                      item.data.map((value) => {
                          value.date = item.date;
                          at1.push(value.date.substr(5));
                      });
                  });
                  let at2 = [];
                  at1.map((item, index) => {
                      if (index > 0 && item == at1[index - 1]) {
                          at2.push("");
                      } else {
                          at2.push(item);
                      }
                  });

                  this.$set(this.tempScheduleItem, 'timeList', at2)

                  this.scheduleList.push(this.tempScheduleItem)
                  this.tempScheduleItem = {};
                }

                this.getHeight();

            });
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/var.scss";
.agenda {
    width: 693px;
    height: 431px;
    background-color: #ffff;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0px 8px 10px 4px rgba(0, 0, 0, 0.3);
    border-radius: 20px;
    box-sizing: border-box;
    padding: 15px 19px 0;
    z-index: 20;
    h1 {
        width: 100%;
        height: 28px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #09468c;
        line-height: 28px;
        text-align: center;
    }
    .list-no{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 150px;
        font-size: 22px;
    }
    .list {
        width: 100%;
        height: 328px;
        margin-top: 40px;
        box-sizing: border-box;
        padding-left: 4px;
        overflow-y: scroll;
        background-color: transparent;

        .lineBox {
            width: 95px;
            height: 100%;
            box-sizing: border-box;
            position: relative;
            .year {
                position: absolute;
                font-size: 21px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #909090;
                /* margin-top: 40px; */
                margin-left: -5px;
            }
            .dot {
                width: 11px;
                height: 11px;
                background: #909090;
                position: absolute;
                left: 50px;
                border-radius: 50%;
                background: #909090;
                .date {
                    position: absolute;
                    font-size: 17px;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #09468c;
                    line-height: 22px;
                    left: -53px;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }

            .line {
                width: 1px;
                background: #909090;
                position: absolute;
                left: 55px;
            }
            .active {
                background: #09468c;
            }
        }
        ul {
            width: 100%;
            .theme {
                color: #09468c;
                width: 520px;
                font-size: 16px;
                line-height: 22px;
                text-align: center;
                margin: 5px 0 15px;
            }
            .item {
                width: 520px;
                background: #ffffff;
                box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.2);
                border-radius: 20px;
                margin-bottom: 33px;
                box-sizing: border-box;
                padding: 17px 26px 21px 30px;
                position: relative;
                &:last-child {
                    margin-bottom: 15px;
                }
                .top {
                    width: 100%;
                    display: flex;
                    align-items: flex-start;
                    margin-bottom: 20px;
                    > span {
                        font-size: 12px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #000000;
                        width: 72px;
                        flex-shrink: 0;
                        margin-top: 5px;
                    }
                    > h2 {
                        font-size: 16px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #656565;
                        line-height: 22px;
                        margin-left: 7px;
                        width: 270px;
                    }
                }
                .bottom {
                    min-height: 20px;
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #aeaeae;
                    line-height: 17px;
                    display: flex;
                    flex: 1;
                    align-items: center;
                    margin-bottom: 7px;
                    .btn {
                        height: 20px;
                        box-sizing: border-box;
                        padding: 1px 7px 2px 7px;
                        background-color: #fff;
                        border-radius: 7px;
                        font-weight: 600;
                        color: #84a2c5;
                        font-size: 12px;
                        margin-left: 10px;
                        cursor: pointer;
                    }
                    .btn:hover {
                        background: #e6ecf3;
                    }
                }
                .playVideo {
                    width: 87px;
                    height: 33px;
                    background: #09468c;
                    border-radius: 8px;
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #ffffff;
                    position: absolute;
                    top: 17px;
                    right: 26px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    > img {
                        width: 10px;
                        margin-right: 7px;
                    }
                }
                .bc {
                    background: #a8a8a8;
                    color: #ffffff;
                }
            }
            .whiteBox {
                width: 100%;
                height: 20px;
            }
        }
    }
    .list::-webkit-scrollbar {
        width: 8px;
        height: 100%;
        background-color: #fff;
    }
    .list::-webkit-scrollbar-thumb {
        width: 2px;
        height: 20%;
        background: #d8d8d8;
        border-radius: 4px;
    }
}
.backHome {
    width: 33px;
    height: 33px;
    position: absolute;
    top: 21px;
    right: 21px;
    border-radius: 50%;
    > img {
        width: 100%;
        height: 100%;
    }
}
.backHome:hover {
    background-color: #e8eef4;
}
</style>



// WEBPACK FOOTER //
// src/components/schedule/index.vue